export default __webpack_public_path__ + "static/media/Memorabilia4.71b60f39.png";